import Seo from 'common/components/seo.component';
import HomeContainer from 'common/containers/home.container';
import { APP_NAME, APP_URL } from 'config/constants/api.constants';
import { AuthErrorType } from 'config/constants/auth.constants';
import { GeneralTranscription } from 'config/constants/transcription.constant';
import SettingService from 'config/services/setting.service';
import { SeoOpenGraphType } from 'config/types/common.type';
import React, { useEffect, useRef } from 'react'; // 💡 Importamos useRef
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/index';
import { SettingSlice } from 'store/slices/setting.slice';
import HomeSkeleton from './skeleton';
import { getAuthErrorCode, getErrorMessage } from 'config/utils/errors.util';
import { SnackbarUtilities } from 'config/utils/snackbar.util';

const openGraphTags: SeoOpenGraphType[] = [
  { property: 'title', content: APP_NAME },
  { property: 'url', content: APP_URL },
  { property: 'site_name', content: APP_NAME },
  { property: 'description', content: 'Tu mejor sitio de compras' },
];

const Home: React.FC = () => {
  const dispatch = useDispatch();
  const hasFetchedHome = useRef(false);
  const { setting, user, auth, cart } = useSelector((state: RootState) => state);

  const getHome = async () => {
    dispatch(SettingSlice.fetchingRefresh(true));
    try {
      const homeResponse = await SettingService.getHome();
      dispatch(SettingSlice.refreshHomeIslands(homeResponse.homeIslands || []));
      if (homeResponse.countryDisplay) {
        dispatch(SettingSlice.refreshCountryDisplay(homeResponse.countryDisplay));
      }
    } catch (error: unknown) {
      if (getAuthErrorCode(error) !== AuthErrorType.JWT_EXPIRED) {
        SnackbarUtilities.error(getErrorMessage(error, GeneralTranscription.HOME_ERROR));
      }
    } finally {
      dispatch(SettingSlice.fetchingRefresh(false));
    }
  };

  useEffect(() => {
    if (!hasFetchedHome.current) {
      getHome();
      hasFetchedHome.current = true;
    }
  }, []);

  return (
    <React.Fragment>
      <Seo title={GeneralTranscription.HOME} openGraphTags={openGraphTags} />
      {setting.isFetching && <HomeSkeleton />}
      {!setting.isFetching && (
        <HomeContainer homeIslands={setting.homeIslands ?? []} user={user.userProfile} auth={auth} cart={cart} rotate={user.isFetching} />
      )}
    </React.Fragment>
  );
};

export default Home;
